import React from 'react';
import {RiArrowDropDownLine} from "react-icons/ri";
import {Grid, MenuItem, Select} from "@mui/material";
import {SelectChangeEvent} from "@mui/material/Select";
import {styled} from "@mui/material/styles";

interface DropdownMenuProps {
    options: any[];
    id?: string;
    selectedOption: any;
    onSelect: (option: any) => void;
    onMoreClick?: () => void;
}

const CustomSelect = styled(Select)({
    backgroundColor: "#7B80FF",
    fontFamily: "Mulish, sans-serif",
    fontWeight: "bold",
    fontSize: 16,
    color: "white",
    "& .MuiSelect-icon": {
        color: "white",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#7B80FF",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
    },
});


const DropdownMenu: React.FC<DropdownMenuProps> = ({
                                                       options,
                                                       id = 'id',
                                                       selectedOption,
                                                       onSelect,
                                                   }) => {

    const handleChangeMenu = (event: SelectChangeEvent<any>) => {
        const selected = options.find(option => option[id] === event.target.value);
        console.log('selected', selected)
        console.log('event.target.value', event.target.value)
        if (selected) onSelect(selected);
    };

    return (

    <Grid item>
        <CustomSelect
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedOption}
            onChange={handleChangeMenu}
            IconComponent={RiArrowDropDownLine}
        >
            {options.map((menu) => (
                <MenuItem key={menu.id} value={menu.id}>
                    {menu.label}
                </MenuItem>
            ))}
        </CustomSelect>
    </Grid>
    );
};

export default DropdownMenu;
